import React, { Component } from "react";
import classNames from "classnames";
import SlideVerticalAnimation from "ReactComponents/Shared/AnimationComponents/slide-vertical-animation";
import IconArrow from "ReactComponents/Shared/Icons/icon-arrow";
import { kebabCase } from "js/utils/string";

class FaqsListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: global.canUseDOM && isPageEditor
        };
        this.toggleItem = this.toggleItem.bind(this);
    }

    toggleItem() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        const className = classNames("faq-item", {
            isOpen: this.state.open
        });

        const kebabCaseTitle = kebabCase(this.props.title);

        return (
            <div className={className}>
                <button
                    id={`faq-item-button-${kebabCaseTitle}`}
                    aria-expanded={this.state.open}
                    type="button"
                    className="faq-item__title"
                    onClick={this.toggleItem}
                    aria-controls={`faq-item-${kebabCaseTitle}`}
                >
                    <span dangerouslySetInnerHTML={{ __html: this.props.title }}></span>
                    <div className="faq-item__title__arrow">
                        <IconArrow direction="down" />
                    </div>
                </button>
                <SlideVerticalAnimation visible={this.state.open}>
                    <div className="faq-item__content">
                        <div
                            id={`faq-item-${kebabCaseTitle}`}
                            aria-labelledby={`faq-item-button-${kebabCaseTitle}`}
                            className="faq-item__content__inner"
                            dangerouslySetInnerHTML={{ __html: this.props.content }}
                        ></div>
                    </div>
                </SlideVerticalAnimation>
            </div>
        );
    }
}

export default FaqsListItem;
